<template>
  <div class="top">
    <el-dropdown @command="handleCommand" class="margin-right-20 cursor-pointer">
      <span class="el-dropdown-link">
        {{$i18n.locale | localeFormat}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command='zh'>中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-popover  placement="bottom" trigger="hover" :visible-arrow="false" width="200">
      <el-avatar slot="reference" icon="el-icon-user-solid" :size="32"></el-avatar>
      <div class="popover">
        <div class="popover_item text_size_12" @click="$router.push('/userinfo')">{{$t('topedit.layout.top.grxx')}}</div>
        <div class="popover_item text_size_12" @click="signOut">{{$t('topedit.layout.top.tcdl')}}</div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import cookie from '~/config/cookie'
import {PLATFORM_URL_ZH} from '~/config'

export default {
  data () {
    return {
    }
  },
  computed: {
    role () {
      return this.$store.state.userInfo.role
    }
  },
  created () {
    this.$store.dispatch('getUserInfo')
  },
  methods: {
    signOut () {
      this.$store.commit('SET_USER_INFO', {})
      cookie.remove('en_token')

      this.$router.push('/login')
    },
    handleCommand (command) {
      if (command === 'zh') {
        // 切换中文站
        this.$store.commit('SET_USER_INFO', {})
        cookie.remove('en_token')
        location.href = PLATFORM_URL_ZH
      }
      // this.$i18n.locale = command
      // cookie.set('locale', this.$i18n.locale)
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  height: 60px;
  padding-right: 40px;
  background-color: #fff;
  box-shadow:0px 0px 10px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.popover {
  &_item {
    line-height: 40px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    &:hover {
      background-color: $--color-primary-light-9;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/top/index.vue